export const checkUsername = (username, minLength, maxLength) => {
  if (username.length < minLength) {
    console.log("Too short");
    return { type: "REG_ERROR_USERNAME_TOO_SHORT" };
  } else if (username.length > maxLength) {
    return { type: "REG_ERROR_USERNAME_TOO_LONG" };
  } else {
    return { type: "REG_ERROR_USERNAME_RESET" };
  }
};

export const setUsernameDuplicateWarning = () => {
  return { type: "REG_ERROR_USERNAME_USED" };
};

export const resetUsernameWarning = () => {
  return { type: "REG_ERROR_USERNAME_RESET" };
};

export const checkPassword = (minLength, password) => {
  if (password.length < minLength) {
    return { type: "REG_ERROR_PASSWORD_TOO_SHORT" };
  } else {
    return { type: "REG_ERROR_PASSWORD_RESET" };
  }
};

export const resetPasswordWarning = () => {
  return { type: "REG_ERROR_PASSWORD_RESET" };
};

export const setProgressUpdater = (prg) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    const uid = getState().firebase.auth.uid;
    firestore
      .collection("users")
      .doc(uid)
      .update({
        progress: prg,
      })
      .then(() => {
        dispatch({ type: "PROGRESS_UPDATE_SUCCESS" });
      })
      .catch((err) => {
        dispatch({ type: "PROGRESS_UPDATE_ERROR", err });
      });
  };
};

export const resetProgressVar = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_PROGRESS_VAR" });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/regActions.tsx